// Import Vendors
import FarloUiLightbox from './vendors/farlo-ui-lightbox';
import FarloUiSelectBox from './vendors/farlo-ui-selectbox';
import FarloUiRevolverCarousel from './vendors/farlo-ui-revolver-carousel';

// Import Footer Components
import { cookieCompliance } from './components/footer/cookieCompliance.js';
import { farloUiCrmSignup } from './components/footer/farloUiCrmSignup.js';
import { elementInView } from './components/footer/elementInView.js';
import { faqs } from './components/footer/faqs';
import { navicon } from './components/footer/navicon.js';
import { navigation } from './components/footer/navigation.js';
import { smoothScroll } from './components/footer/smoothScroll.js';

((document, window, history) => {
	const pushState = history.pushState;

	history.pushState = function (state) {
		if (typeof history.onpushstate === 'function') {
			history.onpushstate({ state });
		}
		return pushState.apply(history, arguments);
	};

	document.addEventListener('DOMContentLoaded', () => {
		if (document.querySelector('.site-navigation__navicon')) {
			navicon();
		}

		if (document.querySelector('.site-navigation__sub-menu')) {
			document
				.querySelectorAll('.site-navigation__sub-menu')
				.forEach((_sel) => {
					navigation(_sel);
				});
		}

		if (document.querySelector('.farlo-ui-crm--inline')) {
			document.querySelectorAll('[farlo-ui="crm"]').forEach((_sel) => {
				farloUiCrmSignup(_sel);
			});
		}

		if (document.querySelector('.farlo-ui-crm__toggle')) {
			document
				.querySelectorAll('.farlo-ui-crm__toggle')
				.forEach((_sel) => {
					_sel.addEventListener('click', (e) => {
						e.preventDefault();
						e.stopImmediatePropagation();
						farloUiCrmSignup(e);
					});
				});
		}

		if (document.querySelector('.farlo-ui-biscuit-banner')) {
			cookieCompliance();
		}

		document.querySelectorAll('a[href*="#"]').forEach((_sel) => {
			smoothScroll(_sel);
		});

		if (document.querySelector('.site-faqs')) {
			faqs();
		}

		if (document.querySelector('.farlo-ui-animated')) {
			document.querySelectorAll('.farlo-ui-animated').forEach((_sel) => {
				elementInView(_sel);
			});
		}

		if (document.querySelector('.farlo-ui-ticket-calendar')) {
			document
				.querySelectorAll('[farlo-ui="calendar"]')
				.forEach((_sel) => {
					_sel.farloUiTicketCalendar(_sel);
				});
		}

		if (document.querySelector('select')) {
			document.querySelectorAll('select').forEach((_sel) => {
				new FarloUiSelectBox(_sel);
			});
		}

		if (document.querySelector('.farlo-ui-lightbox__toggle')) {
			document
				.querySelectorAll('.farlo-ui-lightbox__toggle')
				.forEach((_sel) => {
					new FarloUiLightbox(_sel);
				});
		}

		if (document.querySelector('.farlo-ui-revolver-carousel')) {
			document
				.querySelectorAll('[farlo-ui="carousel"]')
				.forEach((_sel) => {
					new FarloUiRevolverCarousel(_sel);
				});
		}
	});

	if (typeof navigator !== 'undefined') {
		navigator.serviceWorker
			.getRegistrations()
			.then(function (registrations) {
				for (const registration of registrations) {
					registration.unregister();
				}
			});
	}

	function showMessage() {
		if (document.querySelector('#input_1_16').value === 'Yes') {
			document.querySelector('#field_1_7').style.display = 'grid';
			document
				.querySelector('#field_1_7')
				.querySelector('textarea').disabled = false;
		} else {
			document.querySelector('#field_1_7').style.display = 'none';
			document
				.querySelector('#field_1_7')
				.querySelector('textarea').disabled = true;
		}
	}
	if (document.querySelector('#input_1_16')) {
		document
			.querySelector('#input_1_16')
			.addEventListener('change', (e) => {
				showMessage();
			});
		showMessage();
	}
})(document, window, history);
